import styled from 'styled-components'

export const TabsContainer = styled.div`
  padding-top: 8px;
`

export const TableContainer = styled.div`
  .DFpagination {
    padding: 0px 0px 47px;
  }
`
export const RowInsuredButton = styled.div`
  width: 32px;
  margin-left: auto;
`

export const RiskDataContainer = styled.div`
  max-width: 1024px;
  margin: auto;

  > .row {
    width: 100%;
    display: flex;
    gap: 32px;
    margin: auto;

    > .col {
      width: 50%;
    }
  }
`

export const RadioSectionContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`

export const DeclarationsContainer = styled.div`
  padding: 0 20px;
`

export const TextWrap = styled.p`
  width: 100%;
  white-space: break-spaces;
  margin: 0;
`
export const Container = styled.div`
  h4 {
    font-family: Ubuntu, sans-serif;
    -webkit-font-smoothing: antialiased;
    letter-spacing: 0.2px;
    font-size: 14px;
    text-align: center;
    color: #f39c12;
  }
`

export const FormContainer = styled.div`
  .DFtextField {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
  }
  .switch-container {
    margin: 24px auto;

    label {
      display: inline-flex;
      align-items: center;
      gap: 16px;
    }

    .text,
    span {
      font-family: Ubuntu, sans-serif;
      color: #646464;
      letter-spacing: 1px;
      font-size: 14px;
      margin: 4px 0;
      display: block;
    }
  }

  > .row {
    width: 100%;
    display: flex;
    gap: 32px;
    margin: auto;

    > .col {
      width: 50%;

      > div,
      .DFdatePicker,
      .DFtextField,
      .DFnumberField {
        margin-top: 0;
      }
    }
  }
`

export const ButtonNextContainer = styled.div`
  display: flex;
  justify-content: end;
  margin: auto;
  align-items: end;

  .button-action {
    margin-left: auto;
    margin-top: 40px;
    button {
      margin: 0;
    }
  }
`

export const ReportDialog = styled.div`
  .wrapperPageTitle {
    > div {
      margin: 0;
      > small {
        display: none;
      }
    }
  }

  .text {
    font-family: Ubuntu;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.2px;
    color: rgb(139, 139, 139);
    margin: 0;
    margin-bottom: 8px;
  }

  .group-buttons {
    padding-top: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 32px;

    button {
      margin: 0;
    }
  }
`
